import UserIDInput from "../components/UserIDInput";

import "../styles/FourHHomePage.css";

export default function HomePage() {
  return (
    <main className="fourHHomepage">
      <UserIDInput />
    </main>
  );
}